import { createContext } from 'react';
export const VirtualSlotsPlaceholderContext = createContext(undefined);
export const VirtualSlotsPlaceholderHighlightContext = createContext({});
export const VirtualSlotsPlaceholderHostId = createContext('');
//# sourceMappingURL=slotsPlaceholderContext.js.map